// One serialized writer per record. Edits made during a request remain dirty.
export function createGalleryAutosave({initial, version, save, notify = () => {}, onSaved = () => {}, persist = () => {}, delay = 700}) {
  let data = initial, currentVersion = version, generation = 0, savedGeneration = 0;
  let timer, inFlight, disposed = false, paused = false, status = 'saved', error = null;
  const publish = () => { if (!disposed) notify({data, status, error}); };
  const flush = () => {
    clearTimeout(timer);
    if (paused) return Promise.resolve(data);
    if (inFlight) return inFlight.then(() => flush());
    if (generation === savedGeneration) return Promise.resolve(data);
    const snapshot = data, requestedGeneration = generation;
    status = 'saving'; error = null; publish();
    inFlight = Promise.resolve().then(() => save(snapshot, currentVersion)).then((updated) => {
      currentVersion = updated.version; savedGeneration = requestedGeneration;
      if (!disposed) onSaved(updated);
      if (generation === requestedGeneration) { persist(null); status = 'saved'; }
      else { status = 'saving'; }
      publish();
    }).catch((failure) => {
      status = 'error'; error = failure; publish(); throw failure;
    }).finally(() => { inFlight = null; });
    return inFlight.then(() => generation === savedGeneration ? data : flush());
  };
  return {
    activate() { disposed = false; paused = false; publish(); },
    async pauseAndDrain() { paused = true; clearTimeout(timer); if (inFlight) await inFlight.catch(() => {}); },
    resume() { paused = false; if (!disposed && generation !== savedGeneration) timer = setTimeout(() => { flush().catch(() => {}); }, delay); publish(); },
    replaceSaved(next, nextVersion) { if (inFlight) throw new Error("Wait for saving before replacing the draft."); clearTimeout(timer); data = next; currentVersion = nextVersion; generation = savedGeneration = 0; status = "saved"; error = null; persist(null); publish(); },
    get: () => data,
    getVersion: () => currentVersion,
    change(next) {
      data = typeof next === 'function' ? next(data) : next; generation += 1;
      persist({data, version: currentVersion}); status = 'saving'; error = null; publish();
      clearTimeout(timer); if (!paused) timer = setTimeout(() => { flush().catch(() => {}); }, delay);
    },
    flush,
    adoptVersion(nextVersion) { currentVersion = nextVersion; },
    dispose() { disposed = true; clearTimeout(timer); },
  };
}
